import api from '../../api/leadRealAPI'
import router from '../../router'

export default {
  namespaced: true,

  state: {
    magazine: {},
    setMagazine: {},
    deleteMsg: null,
    destinationIDs: [],
    emailStatus: null,
    members: []
  },

  getters: {
    magazine: state => state.magazine,
    setMagazine: state => state.setMagazine,
    setEmailStatus: state => state.emailStatus,
    destinationIDs: state => state.destinationIDs,
    members: state => state.members,
    deleteMsg: state => state.deleteMsg
  },

  mutations: {
    allMagazine (state, magazine) {
      state.magazine = magazine
    },
    setMagazine (state, setMagazine) {
      state.setMagazine = setMagazine
    },
    setEmailStatus (state, emailStatus) {
      state.emailStatus = emailStatus
    },
    setMembers (state, members) {
      state.members = members
    },
    setDeleteMsg (state, deleteMsg) {
      state.deleteMsg = deleteMsg
    },
    setDestinationIDs (state, destinationIDs) {
      state.destinationIDs = destinationIDs
    }
  },
  actions: {
    allMagazine ({ commit }) {
      api
        .get('/admin/magazineList')
        .then(response => {
          commit('allMagazine', response.data)
        }).catch(() => {})
    },
    addMagazine ({ commit }, data) {
      api
        .post('/admin/createMagazine', data)
        .then(response => {
          commit('setEmailStatus', response.data.status)
          setTimeout(() => commit('setEmailStatus', null), 3000)
        })
    },
    getMagazine ({ commit }, data) {
      commit('setMagazine', null)
      api
        .get('/admin/magazineSpecific/' + data)
        .then(response => {
          const IDlist = response.data.data.destination_id
          commit('setDestinationIDs', IDlist)
          commit('setMagazine', response.data.data)
        }).catch(() => {})
    },
    updateMagazine ({ commit, state }, data) {
      api
        .post('/admin/magazineUpdate/' + data.id, data.values)
        .then(response => {
          commit('setEmailStatus', response.data.status)
          setTimeout(() => commit('setEmailStatus', null), 3000)
        })
        .catch(() => {})
    },
    deleteEmailMagazine ({ commit, state }, data) {
      api
        .post('/admin/magazineDelete/' + data.id, data)
        .then(response => {
          commit('setDeleteMsg', response.data.status)
          setTimeout(() => commit('setDeleteMsg', null), 3000)
          router.push({ name: 'Email List' })
        })
        .catch(() => {})
    }
  }
}
